
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/download/design-process",
      function () {
        return require("private-next-pages/download/design-process/index.tsx");
      }
    ]);
  